import _ from 'lodash'

function scorecardSeriesDataType (serie, sn) {
	// #23059 the calculated actual value may have a different data type
	// than the scorecard item (like a rollup Yes/No with # of yeses aggregation).
	// If there is a non-null dataType in the scores, use that.
	let scoreDataType = _.map(serie.points, 'dataType').find(t => !!t)

	return scoreDataType || sn.dataType
}

export default scorecardSeriesDataType

scorecardSeriesDataType.__filename__ = 'charts/chart-data/scorecard-series-data-type.js'
